import { createMultiSelectOptionSetValueFromOptionGuid, FieldsToLookupByMasterAttributeId } from "global/Application";
import {
    IGroupConfigurationConfig as FAM_IGroupConfigurationConfig,
    IGroupConfigurationData as FAM_IGroupConfigurationData
} from "model/FlexibleAttributeModel";
import { bcbs_groupconfigurationsnapshot } from "../../model/CRM";
import { Memoize } from "../Utility/TSFunctions";
import { BaseJsonTransformer } from "./IJsonTransformer";
import { $oset_$group_configuration_normal_enrollment_$benefit_company_id, $oset_$group_configuration_normal_enrollment_$bluesenroll_id, $oset_$group_configuration_normal_enrollment_$eexchange_datawise_id, $oset_$group_configuration_normal_enrollment_$hardcopy_id, $oset_$group_configuration_normal_enrollment_$hr_in_touch_id, $oset_$group_configuration_normal_enrollment_$plansource_id, $oset_$ongoing_enrollment_$benefit_company_id, $oset_$ongoing_enrollment_$bluesenroll_id, $oset_$ongoing_enrollment_$eexchange_datawise_id, $oset_$ongoing_enrollment_$hard_copy_id, $oset_$ongoing_enrollment_$hr_intouch_id, $oset_$ongoing_enrollment_$plansource_id } from "model/ConfigOptionSetConstants";
import { $matt_$group_configuration_$bcbs_normalenrollment_id, $matt_$group_configuration_$bcbs_ongoingenrollment_ms_id } from "model/MasterAttributeConstants";

interface IMapping {

    [key: string]: {
        Id: string;
        Name: string;
    };
}

/**
 * Transformers:
 * Moved from Sprint34Transformer.ts
 * Ongoing Enrollment field updated from optionset -> multiselect
 * https://dev.azure.com/blue-infosys/Group%20Library/_sprints/taskboard/Group%20Library%20Team/Group%20Library/Sprint%2035?workitem=502682
 */
export class Sprint35Transformer extends BaseJsonTransformer {
    config: FAM_IGroupConfigurationConfig;
    json: FAM_IGroupConfigurationData;

    constructor({ config, json }: { config: FAM_IGroupConfigurationConfig, json: FAM_IGroupConfigurationData }) {
        super();
        this.config = config;

        this.json = json;

    }

    OnGoingEnrollmentMapping() {
        
        // Define a mapping object
        const OnGoingEnrollmentMappings: IMapping =
        {
            [$oset_$group_configuration_normal_enrollment_$benefit_company_id]: {
                Id: $oset_$ongoing_enrollment_$benefit_company_id,
                Name: "Benefit Company"
            },
            [$oset_$group_configuration_normal_enrollment_$eexchange_datawise_id]:{
                Id: $oset_$ongoing_enrollment_$eexchange_datawise_id,
                Name: "eExchange/Datawise"
            },
            [$oset_$group_configuration_normal_enrollment_$hardcopy_id]:{
                Id: $oset_$ongoing_enrollment_$hard_copy_id,
                Name: "Hardcopy"
            },
            [$oset_$group_configuration_normal_enrollment_$hr_in_touch_id]:{
                Id: $oset_$ongoing_enrollment_$hr_intouch_id,
                Name: "HR InTouch"
            },
            [$oset_$group_configuration_normal_enrollment_$plansource_id]:{
                Id: $oset_$ongoing_enrollment_$plansource_id,
                Name: "PlanSource"
            },
            [$oset_$group_configuration_normal_enrollment_$bluesenroll_id]:{
                Id: $oset_$ongoing_enrollment_$bluesenroll_id,
                Name: "BluesEnroll"
            },

        };
        return {
            OnGoingEnrollmentMappings
        }
    }

    async before(json: FAM_IGroupConfigurationData): Promise<void> {
        console.debug("[tran] Sprint35Transformer.before")
    }

    async transformGroupConfiguration(json: FAM_IGroupConfigurationData, snapshot: bcbs_groupconfigurationsnapshot): Promise<void> {
        
        // random comment moment

        // cache list of fields upon first call
        const fieldInfosMemoized = Memoize(() => {
            return FieldsToLookupByMasterAttributeId(this.config, json.fields);
        });
        
        // --------------------------------------------------------------------------------------------
        

        // map to array of master attributes, first element in array being the visible one.
        const fieldsByMasterAttrId = fieldInfosMemoized();

        //OngoingEnrollment - optionSet (original)
        //https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=722efbb7-be5d-ec11-8f8f-000d3a5a0d43
        const bcbs_ongoingenrollment_masterAttribute_old = fieldsByMasterAttrId[$matt_$group_configuration_$bcbs_normalenrollment_id]
        const bcbs_ongoingenrollment_old = bcbs_ongoingenrollment_masterAttribute_old[0];

        //Ongoing enrollment - multiselect
        //https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=4649f54d-c954-ef11-a317-000d3a17460e
        const bcbs_ongoingenrollment_masterAttribute = fieldsByMasterAttrId[$matt_$group_configuration_$bcbs_ongoingenrollment_ms_id]

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/516942
        // update new field if the old field is populated
        if (bcbs_ongoingenrollment_masterAttribute) {
        const bcbs_ongoingenrollment = bcbs_ongoingenrollment_masterAttribute[0];

            //if old field exists and new field does not have a value, get the value
            const value_bcbs_ongoingenrollment_old = bcbs_ongoingenrollment_old.field.values[0];
            const value_bcbs_ongoingenrollment_old_id = bcbs_ongoingenrollment_old.field.values[0].value?.type === "entity" ? bcbs_ongoingenrollment_old.field.values[0].value.id : "";
            const value_bcbs_ongoingenrollment = bcbs_ongoingenrollment.field.values[0];
            
            if (value_bcbs_ongoingenrollment_old_id && !value_bcbs_ongoingenrollment.value) {
                //need to parse out the values from the old optionset
                var ongoingEnrollmentOptionsetValue = this.OnGoingEnrollmentMapping().OnGoingEnrollmentMappings[value_bcbs_ongoingenrollment_old_id];
                
                if(ongoingEnrollmentOptionsetValue)
                {
                    var listOfGuids: string[] = [];
                    //build list of guids
                    listOfGuids.push(ongoingEnrollmentOptionsetValue.Id);

                    bcbs_ongoingenrollment.field.values[0].value = createMultiSelectOptionSetValueFromOptionGuid(this.config, listOfGuids);
                }
            }
        }
    }

    async after(json: FAM_IGroupConfigurationData): Promise<void> {

        console.debug("[tran] Sprint35Transformer.after")

        if (!json.transformers)
            json.transformers = {};

        json.transformers.Sprint35 = true

    }
}
